import {styled} from "@mui/styles";
import {TableCell, tableCellClasses} from "@mui/material";

styled(TableCell)(({theme}) => ({

    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#163263',
    },
    [`&.${tableCellClasses.body}`]: {
        'border-width': 0,
        'padding-left' : 0,

    },
}));